import { render, staticRenderFns } from "./Temp.vue?vue&type=template&id=50442526&"
import script from "./Temp.vue?vue&type=script&lang=ts&"
export * from "./Temp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports